import React from "react";
import { noop } from "lodash";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { CrossApplication } from "@tvg/ts-types/CrossApp";
import CrossProductLink from "../../_organisms/CrossProductLink";
import { Container, Content, Title } from "./styled-components";

export const CrossProductNavigation = ({
  products,
  userState,
  onOpenExternalLink = noop
}: {
  products: Array<CrossApplication>;
  userState: string;
  onOpenExternalLink: UnaryFn<CrossApplication, void>;
}) => (
  <Container>
    <Content>
      <Title>Explore FanDuel</Title>
      {products.map((product) => (
        <CrossProductLink
          key={product.productId}
          product={product}
          isAvailable={product.availableStates.includes(userState)}
          onOpenExternalLink={onOpenExternalLink}
          userState={userState}
        />
      ))}
    </Content>
  </Container>
);

export default CrossProductNavigation;
